import { Component, ViewEncapsulation, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BreadcrumbService } from './breadcrumb.service';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);

  public get visible$(): Observable<boolean> {
    return this.breadcrumbService.visible$;
  }
}
